import { useEffect, useState, useMemo } from 'react'

import { GetDynamics as BLGetDynamics, SetDynamic as BLSetDynamic, DeleteDynamicData } from './../../../utilities/BL/Admin/Dashboard/Dynamics'
import { ResetAllResults, SetGenderMode, GetGenderMode as BLGetGenderMode, GetAutozoneState as BLGetAutozoneState, SetAutozoneState as BLSetAutozoneState } from './../../../utilities/BL/Zones'

import { RunToGoal } from './../Games/RunToGoal'
import { RunToGoalV2 } from './../Games/RunToGoalV2'
import { RunToGoalV3 } from './../Games/RunToGoalV3'
import { Base } from './../Commons/Base'
import { Quiz } from './../Games/Quiz'
import { Colors } from './../Games/Colors'
import { Lottery } from './../Games/Lottery'
import { Balloons } from '../Games/Balloons'
import { Riddle } from './../Games/Riddle'
import { SelfieFan } from './../Games/SelfieFan'
import { SelfieFanPlayer } from './../Games/SelfieFanPlayer'
import { QuizzWithImageAndOptions } from './../Games/QuizzWithImageAndOptions'
import { Karaoke } from './../Games/Karaoke'
import { LuchoFest } from './../Games/LuchoFest'
import { LightShow } from './../Games/LightShow'
import { Picnic } from './../Games/Picnic'
import { Tacos } from './../Games/Tacos'
//import { Sonometer } from './../Games/Sonometer'
import { Noisemeter } from './../Overlays/Noisemeter'
import { Messages } from './../Overlays/Messages'
import { PluckingRooster } from './../Overlays/PluckingRooster'
import { InteractiveChat } from './../Overlays/InteractiveChat'
import { Briefcase } from './../Games/Briefcase'

import { Sections } from './Sections'
import { CatchTheBall } from './../Games/CatchTheBall'
import { SlotMachine } from './../Games/SlotMachine'

import { Stadium } from './../Games/Stadium'
import { Voting } from './../Games/Voting'
import { Caps } from './../Games/Caps'
import { Roulette } from './../Games/Roulette'
import { Score } from './../Games/Score'
import { Lineup } from './../Games/Lineup'


const Dashboard = () => {
    // --- ESTADOS ---
    const [showModal, setShowModal] = useState(false);
    const [dynamics, setDynamics] = useState([]); // Data cruda de la API
    const [currentDynamic, setCurrentDynamic] = useState(null); // ID de la dinámica principal activa
    const [currentMessage, setCurrentMessage] = useState(null); // ID del mensaje activo
    const [isActiveWomensMode, setActiveWomensMode] = useState(null);
    const [isAutozoneActive, setAutozoneActive] = useState(null);

    // --- CONFIGURACIÓN ESTÁTICA ---
    // Mapa de Iconos por ID para búsqueda rápida O(1). 
    // Esto evita recorrer arrays constantemente para buscar iconos.
    const ICONS_MAP = {
        1: 'bi bi-qr-code-scan',
        2: 'bi bi-hourglass-split',
        3: 'bi bi-check2-circle',
        4: 'bi bi-ui-checks-grid',
        5: 'bi bi-noise-reduction',
        6: 'bi bi-palette',
        7: 'bi bi-person-raised-hand',
        8: 'bi bi-chat-square-heart',
        9: 'bi bi-balloon',
        10: 'bi bi-question-square',
        //11: 'bi bi-camera', //Fan Cam (v1)
        12: 'bi bi-qr-code-scan',
        13: 'bi bi-gitlab',
        14: 'bi bi-camera',
        15: 'bi bi-file-music',
        16: 'bi bi-speedometer2',
        17: 'bi bi-chat-left-quote',
        18: 'bi bi-qr-code-scan',
        19: 'bi bi-qr-code-scan',
        20: 'bi bi-controller',
        21: 'bi bi-list-ol',
        22: 'bi bi-cake2',
        23: 'bi bi-phone-vibrate',
        24: 'bi bi-chat',
        25: 'bi bi-basket-fill',
        26: 'bi bi-briefcase',
        27: 'bi bi-fork-knife',
        28: 'bi bi-controller',
        29: 'bi bi-coin',
        30: 'bi bi-gear',
        31: 'bi bi-question-circle',
        32: 'bi bi-mortarboard-fill',
        33: 'bi bi-record-circle',
        34: 'bi bi-9-square',
        35: 'bi bi-people-fill'
    };

    // Definición de la estructura de las secciones de dinámicas (API).
    // Aquí definimos qué IDs pertenecen a qué grupo.
    const DYNAMIC_SECTIONS_CONFIG = [
        {
            title: 'Mensajes del aficionado',
            icon: 'bi bi-chat-square-quote',
            ids: [7, 2, 1, 8, 12, 18, 19, 21]
        },
        {
            title: 'Aficionados',
            icon: 'bi bi-people',
            ids: [14, 23] //11 Fan Cam (v1)
        },
        {
            title: 'Overlays',
            icon: 'bi bi-window-desktop',
            ids: [15, 17, 20, 24, 34, 35]
        },
        {
            title: 'Dinámicas 1 vs 1',
            icon: 'bi bi-controller',
            ids: [5, 9, 10, 13, 16, 22, 25, 26, 27, 28, 29, 32, 33]
        },
        {
            title: 'Dinámicas multijugador',
            icon: 'bi bi-controller',
            ids: [3, 4, 6, 9, 10, 13, 16, 22, 29, 31] // Nota: IDs 9, 10, 15, 16 están repetidos según tu lógica original
        },
        {
            title: 'Configuraciones',
            icon: 'bi bi-gear',
            ids: [30]
        }
    ];

    // --- LÓGICA DE NEGOCIO (API CALLS) ---

    const GetGenderMode = async () => {
        try {
            const response = await BLGetGenderMode()

            if (response.success) {
                setActiveWomensMode(response.data.isWomensModeActive)
            } else {
                console.log(response.message)
            }
        } catch (error) {

        }
    }

    const SetWomensMode = async (activeWomensMode) => {
        try {
            const response = await SetGenderMode(activeWomensMode)

            if (response.success) {
                setActiveWomensMode(activeWomensMode)
            } else {
                console.log(response.message)
            }
        } catch (error) {

        }
    }

    const GetAutozoneMode = async () => {
        try {
            const response = await BLGetAutozoneState();

            if (response.success) {
                setAutozoneActive(response.data.isAutozoneActive);
            } else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error?.message);
        }
    };

    const SetAutozoneMode = async (enabled) => {
        try {
            const response = await BLSetAutozoneState(enabled);
            if (response.success) {
                setAutozoneActive(enabled);
            } else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error?.message);
        }
    };

    const GetOutOfTheDynamic = async () => {
        try {
            const response = await DeleteDynamicData()

            if (response.success) {
                document.getElementById("root").classList.remove("Colors__Background__Theme1")
                document.getElementById("root").classList.remove("Colors__Background__Theme2")

                setCurrentDynamic(null)
            } else {
                console.log(response.message)
            }
        } catch (error) {

        }
    }

    const GetDynamics = async () => {
        try {
            // Simulamos la llamada, reemplaza con tu BLGetDynamics real
            const response = await BLGetDynamics();
            if (response.success) setDynamics(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    // Función centralizada para manejar el click en una dinámica de API
    const handleDynamicClick = async (dynamic) => {
        try {
            const response = await BLSetDynamic(dynamic.id);

            if (response.success) {
                // Lógica de reseteo según ID
                if ([3, 4, 5, 9, 10, 11, 13, 14, 15, 16, 17, 20, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35].includes(dynamic.id)) {
                    await ResetAllResults();
                    setCurrentDynamic(dynamic.id);
                    setCurrentMessage(null);
                } else if (dynamic.id === 6) {
                    setCurrentDynamic(6);
                    setCurrentMessage(null);
                } else {
                    // Es un mensaje u otra cosa que no cambia la pantalla principal
                    setCurrentDynamic(null);
                    setCurrentMessage(dynamic.id);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    // Carga inicial
    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete");
            document.getElementById("root").classList.remove("Colors__Background__Theme1", "Colors__Background__Theme2");
            await GetDynamics();
            await GetGenderMode();
            await GetAutozoneMode();
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        LoadPage();
    }, []);

    // --- TRANSFORMACIÓN DE DATOS (Data Processing) ---

    /**
     * Preparación de Datos de Configuración (Zona y Género).
     * Creamos estructuras que imitan a las dinámicas para usar el mismo componente Sections.
     */
    const zoneSectionData = useMemo(() => ({
        title: 'Asignación de zona',
        icon: 'bi bi-shuffle',
        tiles: [
            { id: 'manual', name: 'Manual', icon: 'bi bi-ui-checks', visible: true, enabled: true, action: () => SetAutozoneMode(false), isActive: isAutozoneActive === false },
            { id: 'auto', name: 'Automática', icon: 'bi bi-magic', visible: true, enabled: true, action: () => SetAutozoneMode(true), isActive: isAutozoneActive === true }
        ]
    }), [isAutozoneActive]);

    const genderSectionData = useMemo(() => ({
        title: 'Modo',
        icon: 'bi bi-controller',
        tiles: [
            { id: 'male', name: 'Varonil', icon: 'bi bi-person-standing', visible: true, enabled: true, action: () => SetWomensMode(false), isActive: isActiveWomensMode === false },
            { id: 'female', name: 'Femenil', icon: 'bi bi-person-standing-dress', visible: true, enabled: true, action: () => SetWomensMode(true), isActive: isActiveWomensMode === true }
        ]
    }), [isActiveWomensMode]);

    /**
     * Fusión de Datos de API + Configuración Local.
     * Recorremos la configuración de secciones y rellenamos con la data real de la API.
     */
    const processedDynamicSections = useMemo(() => {
        if (!dynamics || dynamics.length === 0) return [];

        return DYNAMIC_SECTIONS_CONFIG.map(sectionConfig => {
            // Mapeamos los IDs configurados a los objetos reales que vienen de la API
            const sectionTiles = sectionConfig.ids.map(id => {
                // Buscamos la data real en la respuesta de la API
                const apiData = dynamics.find(d => d.id === id);

                // Si la API no trae info para este ID, lo ignoramos
                if (!apiData) return null;

                // Retornamos el objeto fusionado listo para el componente Sections
                return {
                    ...apiData, // id, name, visible, enabled
                    icon: ICONS_MAP[id] || 'bi bi-question-circle', // Fallback de icono
                    action: () => handleDynamicClick(apiData) // Asignamos la acción estándar
                };
            }).filter(Boolean); // Eliminamos nulos (IDs no encontrados en API)

            return {
                title: sectionConfig.title,
                icon: sectionConfig.icon,
                tiles: sectionTiles
            };
        });
    }, [dynamics]); // Solo se recalcula si cambia 'dynamics'


    return (
        <>
            {currentDynamic ? (
                // Renderizado condicional de componentes activos (Quiz, Lottery, etc.)
                // Mantén tu switch original aquí para renderizar <Quiz />, <Lottery />, etc.
                currentDynamic === 3 ? <Quiz getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 4 ? <Lottery getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 5 ? <RunToGoalV3 getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                // currentDynamic === 5 ? <RunToGoalV2 getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 6 ? <Colors getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 9 ? <Balloons getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 10 ? <Riddle getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 11 ? <SelfieFan getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 13 ? <QuizzWithImageAndOptions getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 14 ? <SelfieFanPlayer getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 15 ? <Karaoke getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 16 ? <Noisemeter getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 17 ? <Messages getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 20 ? <PluckingRooster getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 22 ? <LuchoFest getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 23 ? <LightShow getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 24 ? <InteractiveChat getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 25 ? <Picnic getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 26 ? <Briefcase getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 27 ? <Tacos getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 28 ? <CatchTheBall getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 29 ? <SlotMachine getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 30 ? <Stadium getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 31 ? <Voting getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 32 ? <Caps getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 33 ? <Roulette getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 34 ? <Score getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                currentDynamic === 35 && <Lineup getOutOfTheDynamic={GetOutOfTheDynamic} />
                //currentDynamic === 5 ? <RunToGoal getOutOfTheDynamic={GetOutOfTheDynamic} /> :
                // currentDynamic === 16 ? <Sonometer getOutOfTheDynamic={GetOutOfTheDynamic} /> :
            ) : (
                <Base>
                    <div className='AdmDashboard'>
                        <p className='AdmDashboard__Title'>Bienvenid@</p>
                        <p className='AdmDashboard__Subtitle'>Selecciona la opción que desees</p>

                        <div className='AdmDashboard__Container'>
                            {/* 1. Sección de Asignación de Zona (Manual/Auto) */}
                            <Sections
                                title={zoneSectionData.title}
                                sectionIcon={zoneSectionData.icon}
                                tiles={zoneSectionData.tiles}
                                onTileClick={(tile) => tile.action()} // Ejecutamos la acción específica del tile
                                activeId={zoneSectionData.tiles.find(t => t.isActive)?.id} // Pasamos el ID del activo
                            />

                            {/* 2. Sección de Modo (Varonil/Femenil) */}
                            <Sections
                                title={genderSectionData.title}
                                sectionIcon={genderSectionData.icon}
                                tiles={genderSectionData.tiles}
                                onTileClick={(tile) => tile.action()}
                                activeId={genderSectionData.tiles.find(t => t.isActive)?.id}
                            />

                            {/* 3. Secciones Dinámicas (Generadas desde API + Config) */}
                            {processedDynamicSections.map((section, index) => (
                                <Sections
                                    key={index}
                                    title={section.title}
                                    sectionIcon={section.icon}
                                    tiles={section.tiles}
                                    onTileClick={(tile) => tile.action()}
                                    // Comprobamos si el ID activo (currentMessage) coincide con algún tile de este grupo
                                    activeId={currentMessage}
                                />
                            ))}
                        </div>
                    </div>
                </Base>
            )}
        </>
    );
};

export { Dashboard };